import { useState } from "react";
import { Award } from "lucide-react";

// Top Badge — gold-and-black creator badge (owner artwork at /vip-art/top_badge.png).
// Independent of monthly VIP tiers and of Boss · Lifetime; rendered beside the name wherever VipBadge appears.
export default function TopBadge({ show, size = "sm", className = "" }) {
  const [failed, setFailed] = useState(false);
  if (!show) return null;
  const dim = size === "xs" ? "text-[9px] px-1 py-px gap-1" : "text-[10px] px-1.5 py-0.5 gap-1.5";
  const art = size === "xs" ? "w-3.5 h-3.5" : "w-4 h-4";
  return (
    <span
      data-testid="top-badge"
      title="Top Badge — creator award"
      className={`inline-flex items-center whitespace-nowrap shrink-0 border uppercase tracking-widest font-semibold ${dim} text-yellow-200 border-yellow-400/70 bg-gradient-to-r from-yellow-500/25 via-zinc-900/60 to-yellow-500/25 shadow-[0_0_10px_rgba(250,204,21,0.35)] ${className}`}
    >
      {failed ? <Award size={size === "xs" ? 10 : 12} className="text-yellow-300" strokeWidth={1.8} /> : (
        <img src="/vip-art/top_badge.png" alt="Top Badge" onError={() => setFailed(true)} draggable={false}
          className={`${art} object-contain drop-shadow-[0_1px_6px_rgba(0,0,0,0.6)]`} />
      )}
      Top Badge
    </span>
  );
}
